import React from 'react'
import Image from 'next/image'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import floridaServiceArea from '../../../public/Pictures/marketing/florida-service-area-v2.png'
import AudioAction from '../audio/AudioAction'
import Container from '../foundations/Container'
import styles from './FloridaServiceBanner.module.scss'

const FloridaServiceBanner = () => (
  <section
    className={styles.section}
    data-msr-surface='dark'
    aria-labelledby='florida-service-title'
  >
    <Container width='wide' className={styles.container}>
      <div className={styles.content}>
        <h2 id='florida-service-title'>
          Two Florida teams. <span>One MSR.</span>
        </h2>

        <div className={styles.rule} aria-hidden='true' />

        <p>
          Our Miami warehouse serves South Florida, while our Orlando warehouse serves
          Orlando and Central Florida. Planning in Central Florida? Explore the local team,
          inventory, and services on the Orlando site.
        </p>

        <AudioAction
          className={styles.action}
          mode='primary'
          size='large'
          href='/orlando'
        >
          View Orlando Services
          <FiArrowRight aria-hidden='true' />
        </AudioAction>
      </div>

      <div className={styles.art} aria-hidden='true'>
        <Image
          src={floridaServiceArea}
          alt=''
          sizes='(max-width: 599px) 18rem, (max-width: 899px) 24rem, 32rem'
          draggable={false}
        />
      </div>
    </Container>
  </section>
)

export default FloridaServiceBanner
